import lightThemeFactory from './light'

export default function okenLightThemeFactory(
  lightColor: string,
  mainColor: string = lightColor,
  darkColor: string = lightColor,
  secondaryColor: string = lightColor,
  fonts: {
    primary: string
    secondary: string
  }
) {
  const theme = lightThemeFactory(
    lightColor,
    mainColor,
    darkColor,
    secondaryColor,
    fonts
  )
  return theme
}
